/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  XANO_SERVER_URL: 'https://api.respondedu.com',
  NODE_SERVER: 'https://api.respondedu.com',
  GOOGLE_ANALYTICS_API:
    'ya29.a0AfB_byDdmnV4yp0E1Rgm1u5MZdxCcarUJsHzhusFxMgtSj-Imnvv9HsH3Zh4iym3uVWFaotX-tzPugIQLWcCEBUtjuvOHb2W-DDKd35qP4ZllZ_NR42dYjOv9hB7pZijBL-47_1bQq49TtPBsbd9l_E6g140FLsotSEwaCgYKAR0SARESFQGOcNnCn9ZHvkT8eH9U02ZOCMKkCg0171',

  firebaseConfig: {
    apiKey: 'AIzaSyAbfi-3IsJOY54WvxIK25vIe-mu6q0FBJ0',
    authDomain: 'respond-edu.firebaseapp.com',
    projectId: 'respond-edu',
    storageBucket: 'respond-edu.firebasestorage.app',
    messagingSenderId: '26819425507',
    appId: '1:26819425507:web:4c064d52ec0e2c6ea641d6',
    measurementId: 'G-Z6KHWEH64N',
  },

  LOCATION_API: `https://nominatim.openstreetmap.org/reverse?format=jsonv2`,
  LOCATION_WITHOUT_PERMISSION: `https://ipapi.co/json/`,

  JWT_KEY: 'respondedu1234567890123456789012',

  //test key
  // STRIPE_PUBLISHABLE_KEY:
  //   'pk_test_51P41BFL3YMTDe7YHXq8dnhAIl3sRF9tkVRL9hk0AHufBpZL19meAz66kQTUIAHGK1bH1NPC7WsUcLl22Cbrv1Ki300rH9XFRYN',

  // live key
  STRIPE_PUBLISHABLE_KEY:
    'pk_live_51P41BFL3YMTDe7YHBpLPEWE0RT8aZRhyKw9rqHze6GJ7NQAHE403kH9XXlyAooj59TLksHJd7ztthrD8zxS9LPSi00xqBBV05O',
};
